import React from 'react';
import { AlertIcon, CheckCircleIcon, CloseIcon } from './Icons';

const stackStyle = {
  position: 'fixed',
  top: '5rem',
  right: '1.5rem',
  zIndex: 1400,
  display: 'grid',
  gap: '0.75rem',
  width: 'min(420px, calc(100vw - 2rem))',
  pointerEvents: 'none'
};

const FloatingBanner = ({ variant, message, onDismiss }) => {
  const isError = variant === 'error';
  const Icon = isError ? AlertIcon : CheckCircleIcon;
  const color = isError ? 'var(--error)' : 'var(--success)';

  return (
    <div
      role="alert"
      style={{
        pointerEvents: 'auto',
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr) auto',
        gap: '0.75rem',
        alignItems: 'start',
        padding: '0.9rem 0.95rem',
        border: '1px solid var(--border-light)',
        borderLeft: `4px solid ${color}`,
        borderRadius: '8px',
        backgroundColor: 'var(--bg-card)',
        boxShadow: 'var(--shadow-md)',
        color
      }}
    >
      <Icon size={18} />
      <div style={{ display: 'grid', gap: '0.2rem', minWidth: 0 }}>
        <strong style={{ color, fontSize: '0.78rem', fontWeight: 800 }}>
          {isError ? 'Failed' : 'Success'}
        </strong>
        <span style={{ color: 'var(--text-primary)', fontSize: '0.82rem', lineHeight: 1.45, overflowWrap: 'anywhere' }}>
          {message}
        </span>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        title="Close"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '24px',
          height: '24px',
          padding: 0,
          border: 'none',
          borderRadius: '6px',
          backgroundColor: 'transparent',
          color: 'var(--text-muted)',
          cursor: 'pointer'
        }}
      >
        <CloseIcon />
      </button>
    </div>
  );
};

const FloatingBannerStack = ({ error, success, onDismissError, onDismissSuccess }) => {
  if (!error && !success) return null;

  return (
    <div style={stackStyle}>
      {error && (
        <FloatingBanner
          variant="error"
          message={error}
          onDismiss={onDismissError}
        />
      )}
      {success && (
        <FloatingBanner
          variant="success"
          message={success}
          onDismiss={onDismissSuccess}
        />
      )}
    </div>
  );
};

export default FloatingBannerStack;
